/**
 * @ngdoc    directive
 * @name     csm.ui.directive:csmContent
 * @param    {Expression} content  Expression to evaluate to retrieve the markup string
 * @description
 * This is a utility directive that will take the result of the content expression
 * and compile the contents and add the results to this element. Note: The content
 * property is not specified as a binding of the directive so the current scope can
 * be accessed.
 * */
/* @ngInject */
export function csmContent($compile) {
  return {
    restrict: 'E',
    link: function (scope, element, attr) {
      element.append($compile(scope.$eval(attr.content))(scope));
    }
  };
}

csmContent.$inject = ['$compile'];